var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OutAmount"},[_c('AmountPageOut',{attrs:{"textButton":"确认转出","getAmountNum":_vm.getAmountNum}}),_c('self-popup',{model:{value:(_vm.ShowPopupContent),callback:function ($$v) {_vm.ShowPopupContent=$$v},expression:"ShowPopupContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }